import { OptionWithVenn, SeriesOptionWithVenn, VennSeriesOption } from '../type';

export function isVennSeriesOption(seriesOption: SeriesOptionWithVenn) {
  return seriesOption.type === 'map' && seriesOption.dvType === 'venn';
}

export function eachVennSeriesOption(
  option: OptionWithVenn,
  cb: (series: VennSeriesOption, seriesIndex: number, arr: SeriesOptionWithVenn[]) => void
) {
  const seriesArr = Array.isArray(option.series) ? option.series : [option.series];
  seriesArr.forEach(
    (series: SeriesOptionWithVenn, seriesIndex: number, arr: SeriesOptionWithVenn[]) => {
      if (!isVennSeriesOption(series)) {
        return;
      }
      cb(series as VennSeriesOption, seriesIndex, arr);
    }
  );
}
